export default "__VITE_ASSET__DZ61ZyMI__"